import "../blocks/footer/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // TEMPORARY — lets you preview the "new version available" toast without
  // waiting for a real deploy. Dispatches the same event index.jsx sends
  // when a real update installs, but with no actual waiting service worker,
  // so clicking "Refresh" on the test toast just does a normal page reload
  // instead of activating a real update. Safe to delete once you've
  // confirmed the toast looks and behaves the way you want.
  const handleTestUpdateToast = () => {
    window.dispatchEvent(
      new CustomEvent("swUpdateAvailable", { detail: { waiting: null } })
    );
  };

  return (
    <footer className="footer">
      <p className="footer__description">
        Developed by Tripleten Student Samuel Luo
      </p>
      <button
        type="button"
        className="footer__test-update-button"
        onClick={handleTestUpdateToast}
      >
        (test: preview update toast)
      </button>
      <p className="footer__date">{currentYear}</p>
    </footer>
  );
};

export default Footer;
